import { DatabasePooler, PoolerMode, PoolerUpdate } from "./types";

// The pooler change to send, or undefined when the form leaves it as it is. `enabled` is
// undefined when the form had no pooler controls.
export const poolerUpdate = (
  current: DatabasePooler | undefined,
  enabled: boolean | undefined,
  mode: PoolerMode | undefined
): PoolerUpdate | undefined => {
  if (enabled === undefined) {
    return undefined;
  }
  const modeChanged = enabled && mode !== undefined && mode !== current?.mode;
  if (enabled === Boolean(current?.enabled) && !modeChanged) {
    return undefined;
  }
  return { enabled, ...(enabled && mode ? { mode } : {}) };
};

// Turning an enabled pooler off, or switching its mode, drops every connection through it.
export const poolerDisconnectsClients = (
  current: DatabasePooler | undefined,
  update: PoolerUpdate | undefined
): boolean => Boolean(current?.enabled) && update !== undefined;
